import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const SummaryRoot = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const SummaryHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    paddingX: '4px',
  },
})

const SummaryTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.5px',
  },
})

const SummaryLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.primary',
    textDecoration: 'none',
    cursor: 'pointer',
    _hover: {
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
})

const CardGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '12px',
  },
})

const Card = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '18px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.12)',
    border: '1.5px solid transparent',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, transform {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: '#E5E0F5',
      transform: 'translateY(-2px)',
    },
  },
})

const CardTopRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
})

const CardName = styled('h3', {
  base: {
    fontFamily: 'display',
    fontSize: '16px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.3px',
  },
})

const FrequencyChip = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '20px',
    paddingX: '8px',
    borderRadius: 'pill',
    backgroundColor: '#F1ECFF',
    color: 'quickpass.primary',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
})

const CardCriteria = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.4',
  },
})

const CardMeta = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    margin: '0',
    opacity: '0.85',
  },
})

const CardMatches = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    margin: '0',
  },
})

const CardActions = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '4px',
  },
})

const RunNowButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    backgroundColor: '#F1ECFF',
    border: '1.5px solid transparent',
    borderRadius: 'pill',
    paddingX: '12px',
    paddingY: '6px',
    cursor: 'pointer',
    transition: 'background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      backgroundColor: '#E5DCFF',
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: '0.6',
    },
  },
})

const ViewLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    textDecoration: 'none',
    cursor: 'pointer',
    _hover: {
      color: 'quickpass.primary',
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
})

const EmptyTile = styled(Link, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '8px',
    padding: '32px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    color: 'inherit',
    textDecoration: 'none',
    cursor: 'pointer',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, transform {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      transform: 'translateY(-2px)',
    },
  },
})

const EmptyEmoji = styled('span', {
  base: {
    fontSize: '40px',
    lineHeight: '1',
  },
})

const EmptyTitle = styled('p', {
  base: {
    fontFamily: 'display',
    fontSize: '18px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
  },
})

const EmptyBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    margin: '0',
    maxWidth: '420px',
    lineHeight: '1.5',
  },
})

const SkeletonRow = styled('div', {
  base: {
    height: '120px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    border: '1.5px solid #F1ECFF',
    opacity: '0.6',
  },
})

export {
  SummaryRoot,
  SummaryHeader,
  SummaryTitle,
  SummaryLink,
  CardGrid,
  Card,
  CardTopRow,
  CardName,
  FrequencyChip,
  CardCriteria,
  CardMeta,
  CardMatches,
  CardActions,
  RunNowButton,
  ViewLink,
  EmptyTile,
  EmptyEmoji,
  EmptyTitle,
  EmptyBody,
  SkeletonRow,
}
